export default function isOutOfStock(isAvailable: boolean) {
  return !isAvailable;
}
